<template>
  <div>
    <b-row>
      <div class="col-md-6 offset-md-3">
        <hr class="mb-5" />
        <div class="card card-outline-secondary">
          <div class="card-header">
            <h3 class="mb-0">Change Password</h3>
          </div>
          <div class="card-body">
            <b-form @submit="onSubmit">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Current Password*"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="$v.form.currentPassword.$model"
                  type="password"
                  :state="$v.form.currentPassword.$error
                   ? $v.form.currentPassword.required
                    &&
                   $v.form.currentPassword.validateCurrentPassword
                   : null"
                  placeholder="Enter current Password"
                  aria-describedby="current-password-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!$v.form.currentPassword.required || !isValidCurrentPassword"
                  id="current-password-feedback"
                >
                  {{!isValidCurrentPassword
                  ? 'Current password do not match': !$v.form.currentPassword.required
                  ? 'Current Password is required'
                  :''}}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="New Password*"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="$v.form.newPassword.$model"
                  type="password"
                  placeholder="Enter new Password"
                  :state="$v.form.newPassword.$error 
                  ?
                   $v.form.newPassword.required 
                   &&
                   $v.form.newPassword.strongPassword
                   : null"
                  aria-describedby="new-password-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!$v.form.newPassword.required || !$v.form.newPassword.strongPassword"
                  id="new-password-feedback"
                >
                  {{ !$v.form.newPassword.required
                  ? 'New Password is required'
                  : !$v.form.newPassword.strongPassword
                  ? 'New password need to have a letter, a number, a special character, and be equal or more than 8 characters long.'
                  :''
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                class="mb-3"
                id="input-group-3"
                label="Confirm Password*"
                label-for="input-2"
              >
                <b-form-input
                  id="input-3"
                  v-model="$v.form.confirmPassword.$model"
                  type="password"
                  placeholder="Enter confirm Password"
                  :state="$v.form.confirmPassword.$error 
                  ?
                   $v.form.confirmPassword.required 
                   &&
                   $v.form.confirmPassword.sameAsPassword
                   : null"
                  aria-describedby="confirm-password-feedback"
                ></b-form-input>

                <b-form-invalid-feedback
                  v-if="!$v.form.confirmPassword.required || !$v.form.newPassword.sameAsPassword"
                  id="confirm-password-feedback"
                >
                  {{ !$v.form.confirmPassword.required
                  ? 'Confirm Password is required'
                  : !$v.form.confirmPassword.sameAsPassword
                  ? 'The new password and Confirm, password do not match.'
                  :''
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-button type="submit" variant="primary">Submit</b-button>
            </b-form>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { userService } from '../../../Users/service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      isValidCurrentPassword: true
    };
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    ...mapActions('account', ['logout']),
    resetForm() {
      this.form = {
        currentPassword: null,
        newPassword: null,
        confirmPassword: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async onSubmit(evt) {
      evt.preventDefault();
      this.$v.form.$touch();

      let id = this.user.id;
      if (id === undefined) {
        let user = JSON.parse(sessionStorage.getItem('user'));
        id = user.id;
      }

      if (this.form.currentPassword) {
        //VERIFY CURRENT PASSWORD
        const { data } = await userService.verifyCurrentPassword(
          id,
          this.form.currentPassword
        );

        if (data === false) {
          this.isValidCurrentPassword = false;
          return;
        } else {
          this.isValidCurrentPassword = true;
        }
      }

      if (this.$v.form.$anyError) {
        return;
      }

      userService
        .changePassword(
          id,
          this.form.currentPassword,
          this.form.newPassword,
          this.form.confirmPassword
        )
        .then(() => {
          this.$snotify.success('Password updated successful', 'Password');
          this.resetForm();
          this.logout();
        })
        .catch(() => {
          this.$snotify.warning('Wrong password or mismatch', 'Password');
          this.resetForm();
        });
    }
  },
  validations() {
    return {
      form: {
        currentPassword: {
          required,
          validateCurrentPassword() {
            return this.isValidCurrentPassword;
          }
        },
        newPassword: {
          required,
          minLength: minLength(8),
          strongPassword(password1) {
            return (
              /[a-z]/.test(password1) && // checks for a-z
              /[0-9]/.test(password1) && // checks for 0-9
              /\W|_/.test(password1) && // checks for special char
              password1.length >= 8
            );
          }
        },
        confirmPassword: {
          required,
          minLength: minLength(8),
          sameAsPassword: sameAs('newPassword')
        }
      }
    };
  }
};
</script>

